import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";



import { SharedModule } from './shared/shared.module';
import { ConfigModule } from 'ngx-envconfig';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,



    SharedModule,
    ConfigModule.forRoot({state: 'developpement'}),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
